import { render, staticRenderFns } from "./firstBatch.vue?vue&type=template&id=39e84182&"
import script from "./firstBatch.vue?vue&type=script&lang=js&"
export * from "./firstBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports